var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ShortCourseData"},[_c('div',{staticClass:"titlePage"},[_vm._v("Resumen formulario de registro")]),(!_vm.noDtaForm)?_c('div',{staticClass:"listData"},[(_vm.renderComponent1)?_c('DataList',{attrs:{"InfoView":this.DLDataList,"HeadTable":this.HDDataList}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }